// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2pNMY","header":"Messages_header__1SNX8"};